<template>
  <v-card>
    <v-card-title>
      <div class="headline">Applicant Details</div>
    </v-card-title>
    <v-card-text>
      <v-card-title>
        <div class="body-2">Particular</div>
      </v-card-title>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.salutation}}</v-subheader>
          <div class="title">{{formatSalutation(data.insuredInfo.appSalutation)}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.name}}</v-subheader>
          <div class="title">{{data.insuredInfo.appName}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.nricPasport}}</v-subheader>
          <div class="title">{{data.insuredInfo.appNricPassport}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.dob}}</v-subheader>
          <div class="title">{{data.insuredInfo.appDob}}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.gender}}</v-subheader>
          <div class="title">{{formatGender(data.insuredInfo.appGender)}}</div>
        </v-flex>
        <v-flex xs5 v-if="appID === 'TR'">
          <v-subheader class="queryLabel">{{labels.isStudent}}</v-subheader>
          <div class="title">{{formatBoolean(data.insuredInfo.appIsStudent)}}</div>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-3"></v-divider>
      <v-card-title>
        <div class="body-2">Contact Information</div>
      </v-card-title>
      <v-layout row wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.email}}</v-subheader>
          <div class="title">{{data.insuredInfo.appEmail}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.mobileNo}}</v-subheader>
          <div class="title">{{data.insuredInfo.appMobileNo}}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.homeNo}}</v-subheader>
          <div class="title">{{data.insuredInfo.appTelNo1 ? data.insuredInfo.appTelNo1 : 'N/A'}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.officeNo}}</v-subheader>
          <div class="title">{{data.insuredInfo.appTelNo2 ? data.insuredInfo.appTelNo2 : 'N/A'}}</div>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-3"></v-divider>
      <v-card-title>
        <div class="body-2">Applicant Address</div>
      </v-card-title>
      <v-layout row wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.unitNo}}</v-subheader>
          <div class="title">{{data.insuredInfo.appAdd3 ? data.insuredInfo.appAdd3 : 'N/A'}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.postalCode}}</v-subheader>
          <div class="title">{{data.insuredInfo.appPostalCode}}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.blockHouseNo}}</v-subheader>
          <div class="title">{{data.insuredInfo.appAdd1}}</div>
        </v-flex>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.streetName}}</v-subheader>
          <div class="title">{{data.insuredInfo.appAdd2}}</div>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs5>
          <v-subheader class="queryLabel">{{labels.buildingName}}</v-subheader>
          <div class="title">{{data.insuredInfo.appAdd4 ? data.insuredInfo.appAdd4 : 'N/A'}}</div>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-3"></v-divider>
      <div><!-- <div v-if=data.mailAdd> -->
        <v-card-title>
          <div class="body-2">Mailing Address</div>
        </v-card-title>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.unitNo}}</v-subheader>
            <div class="title">{{data.insuredInfo.mailAdd3 ? data.insuredInfo.mailAdd3 : 'N/A'}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.postalCode}}</v-subheader>
            <div class="title">{{data.insuredInfo.mailPostalCode}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.blockHouseNo}}</v-subheader>
            <div class="title">{{data.insuredInfo.mailAdd1}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.streetName}}</v-subheader>
            <div class="title">{{data.insuredInfo.mailAdd2}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.buildingName}}</v-subheader>
            <div class="title">{{data.insuredInfo.mailAdd4 ? data.insuredInfo.mailAdd4 : 'N/A'}}</div>
          </v-flex>
        </v-layout>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { globalMixin } from './globalMixin'

export default {
  data() {
    return {
      labels: {
        salutation: 'Salutation',
        name: 'Name as in NRIC/Passport',
        nricPasport: 'NRIC/Passport No.',
        dob: 'Date of Birth',
        gender: 'Gender',
        isStudent: 'Are you a full time student?',
        email: 'Email',
        mobileNo: 'Mobile No.',
        homeNo: 'Home No.',
        officeNo: 'Office No.',
        unitNo: 'Unit No.', // add3
        postalCode: 'Postal Code',
        blockHouseNo: 'Block/House No', // add1
        streetName: 'Street Name', // add2
        buildingName: 'Building Name' // add4
      }
    }
  },
  methods: {

  },
  computed: {
    data() {
      return this.$store.state.adminMember.member.trans
    }
  },
  props: ['appID', 'id'],
  mixins: [globalMixin]
}
</script>

<style>
</style>
